<h2 mat-dialog-title>{{ data.title }}</h2>
<p *ngIf="skippingPmDetermination()" class="note">
  {{ predeterminedNote }}
</p>
<p *ngIf="hasRecommendation()" class="note">{{ recommendationNote }}</p>
<p>
  {{ data.description }}
</p>
<p *ngIf="hasWarning()" class="warning">{{ data.warning }}</p>

<das-reason-codes
  [recommendedReasonCodes]="recommendedReasonCodes"
  (reasonCodeSender)="setReasonCodes($event)"
></das-reason-codes>
<mat-hint>
  Please contact
  <a href="mailto:departures@nationalhighways.co.uk?subject=Reason%20Codes" style="color:inherit;">DAS Admin</a>
  for any guidance or queries relating to Reason Codes.</mat-hint
>
<mat-form-field>
  <textarea
    cdkTextareaAutosize
    #autosize="cdkTextareaAutosize"
    matInput
    type="text"
    placeholder="Add a comment"
    [formControl]="inputComment"
    [required]="data.commentRequired"
  >
  </textarea>
  <mat-error>
    {{ errorText() }}
  </mat-error>
</mat-form-field>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" color="primary">CANCEL</button>
  <button
    mat-flat-button
    (click)="confirmAndClose()"
    color="primary"
    [disabled]="!inputComment.valid || !reasonCodes.length"
    enableDefaultFocus
  >
    CONFIRM & CLOSE
  </button>
</mat-dialog-actions>
